export interface ParsedAddress {
  city?: string;
  state?: string;
  postalCode?: string;
}

export function parseAddress(address: string): ParsedAddress {
  // Split the address by comma and trim spaces.
  const parts = address.split(",").map((part) => part.trim());
  const total = parts.length;
  let city: string | undefined;
  let state: string | undefined;
  let postalCode: string | undefined;

  // Country is always the last element (we assume "United States" here).
  if (total >= 3 && /^\d{5}$/.test(parts[total - 2])) {
    postalCode = parts[total - 2];
    state = parts[total - 3];
  } else if (total >= 2) {
    state = parts[total - 2];
  }

  if (parts.length > 3 && /^\d+/.test(parts[0])) {
    city = parts[2];
  } else {
    city = parts[0];
  }

  return { city, state, postalCode };
}
